import { render } from "./Permissions-page.vue?vue&type=template&id=15f272e3"
import script from "./Permissions-page.vue?vue&type=script&lang=js"
export * from "./Permissions-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__